import { TokenPayload } from "@/types/app/tokenPayload";
import UserInterface from "@/types/app/IUser";
import Http from "@/plugins/http";
import { TokenStorage } from "@/utils/tokenStorage";

export default class Auth {
  private http = new Http();

  public getUserDataFromToken(): TokenPayload {
    const tokenData = TokenStorage.getToken();
    const userData = this.parseJwt(tokenData);
    return userData;
  }

  public getUserFromToken(): UserInterface | null {
    const userData = this.getUserDataFromToken();
    if (userData) {
      return {
        name: userData.preferred_username,
        email: userData.email,
        id: userData.id,
        isAdmin: userData.role.includes("admin"),
        isLCM: userData.role.includes("admin") || userData.role.includes("lcm"),
      } as UserInterface;
    }

    return null;
  }

  public login(token: string, refreshToken: string): void {
    TokenStorage.storeToken(token);
    TokenStorage.storeRefreshToken(refreshToken);
  }

  public requireAuth = async (to: any, from: any, next: any) => {
    const token = TokenStorage.getToken();

    if (!token || token == null) {
      next({ path: "/login" });
    } else {
      next();
    }
  };

  public parseJwt = (token: string | null) => {
    if (token == null) return null;

    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace("-", "+").replace("_", "/");
    const json = decodeURIComponent(escape(window.atob(base64)));

    return JSON.parse(json);
  };
}
